import { AxiosError } from 'axios';

interface ApiErrorPayload {
  errorCode?: string;
  message?: string | string[];
  errors?: string[];
}

export interface ApiErrorMeta {
  errorCode?: string;
  message?: string;
  errors?: string[];
}

export function getApiErrorMeta(error: unknown): ApiErrorMeta | undefined {
  if (!(error instanceof AxiosError)) return undefined;

  const data = error.response?.data as ApiErrorPayload | undefined;
  const message = Array.isArray(data?.message) ? data.message[0] : data?.message;

  return {
    errorCode: data?.errorCode,
    message: message ?? error.message,
    errors: data?.errors,
  };
}
